import React, { Component } from 'react'
import _ from 'lodash'
import { Grid, Row, Col, ButtonToolbar, FormGroup, ControlLabel } from 'react-bootstrap'
import Validation from 'react-validation'
import NKIcon from '@norkart/ikoner'
import NkaButton from 'nka-button'

import { datoFormatTall } from '../../felles/utils/dato-format-tabell'
import ModalImageCapture from '../../felles/Bilder/modal-image-capture'
import InfoOmStandModal from './infomaalerstandmodal'

import 'nka-checkbox/dist/style.css'
import 'nka-button/dist/style.css'
import '../../felles/valideringsRegler'
import './vannmaaler.css'

export default class Gammelmaaler extends Component {
    constructor(props) {
        super(props)

        this.state = {
            bildeAvMaaler: [],
            taBilde: false,
            stand: this.props.maalerInfo === null ? '' : this.props.maalerInfo.Stand,
            maalerGattRundt: false,
            visInfoOmStand: false
        }

        this._ferdig = this._ferdig.bind(this)
        this._avbryt = this._avbryt.bind(this)
        this._handleStandEndret = this._handleStandEndret.bind(this)
        this._taBildeAvGammelMaaler = this._taBildeAvGammelMaaler.bind(this)
        this._bildeTatt = this._bildeTatt.bind(this)
        this._slettBilde = this._slettBilde.bind(this)
        this._lagBildeElmement = this._lagBildeElmement.bind(this)
        //this._handleMaalerGattrundt = this._handleMaalerGattrundt.bind(this)
        this._standErOkFraDialog = this._standErOkFraDialog.bind(this)
        this._closeInfoOmStandModal = this._closeInfoOmStandModal.bind(this)
    }

    _handleStandEndret(data) {
        this.setState({
            stand: data.target.value
        })
    }

   

    _taBildeAvGammelMaaler() {
        this.setState({
            taBilde: true
        })
    }

    _bildeTatt(image, tekst) {
        var bilder = this.state.bildeAvMaaler

        let bildeObj = {
            Id: bilder.length,
            Bilde: image,
            Kommentar: tekst ? tekst : 'Demontert måler '
        }

        bilder.push(bildeObj)

        this.setState({
            bildeAvMaaler: bilder,
            taBilde: false
        })
    }

    _slettBilde(id) {
        var bilder = this.state.bildeAvMaaler

        var oppdatert = _.filter(bilder, function(bilde) {
            return bilde.Id !== id
        })

        this.setState({
            bildeAvMaaler: oppdatert
        })
    }

    _lagBildeElmement(bilde) {
        if (bilde.Bilde) {
            return (
                <Col xs={12} key={bilde.Id}>
                    <div className="bilde">
                        <img src={bilde.Bilde} width="150" height="100" alt={bilde.Kommentar} />
                        <button
                            className="delete-button"
                            onClick={() => this._slettBilde(bilde.Id)}
                        >
                            <NKIcon icon="soppelbotte" size="1" color="nk-black" />
                        </button>
                    </div>
                </Col>
            )
        }
    }

    _ferdig = event => {
        event.preventDefault()

        if (
            parseInt(this.state.stand, 10) < parseInt(this.props.sisteStand, 10)
        ) {
            this.setState({
                visInfoOmStand: true
            })
        } else {
            this.props.onClose(
                this.state.bildeAvMaaler,
                this.state.stand,
                this.state.maalerGattRundt
            )
        }
    }

    _standErOkFraDialog(maalerGattRundt) {
        this.props.onClose(this.state.bildeAvMaaler, this.state.stand, maalerGattRundt)
    }

    _closeInfoOmStandModal() {
        this.setState({
            visInfoOmStand: false
        })
    }

    _avbryt() {
        this.props.onClose(null, '')
    }

    render() {
        var sisteAvlesningsDato = datoFormatTall(this.props.sisteAvlesningsdato)
        var bilder = _.map(this.state.bildeAvMaaler, this._lagBildeElmement)
        return (
            <Grid>
                <Row>
                    <Col xs={12}>
                        <NkaButton icon="kamera" onClick={this._taBildeAvGammelMaaler}>
                            Ta bilde
                        </NkaButton>
                    </Col>
                </Row>
                {this.state.taBilde && (
                    <ModalImageCapture visBilekommentar={true} onClose={this._bildeTatt} />
                )}

                <Row>{this.state.bildeAvMaaler.length > 0 && bilder}</Row>

                <Validation.components.Form ref={c => (this.form = c)} onSubmit={this._ferdig}>
                    <Row>
                        <Col xs={12} sm={12}>
                            <FormGroup>
                                <ControlLabel className="paddingTop15">Stand*</ControlLabel>
                                <Validation.components.Input
                                    className="hoeyde48"
                                    errorClassName="is-invalid-input"
                                    type="number"
                                    pattern="\d*"
                                    placeholder="Stand ved uttak"
                                    value={this.state.stand}
                                    validations={['required', 'numeric', 'storreEllerLikNull']}
                                    onChange={this._handleStandEndret}
                                />
                            </FormGroup>
                            
                                           
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={10} sm={7} md={2}>
                            <FormGroup>
                                <ControlLabel className="paddingTop15">Forrige stand</ControlLabel>
                                <p>
                                    {this.props.sisteStand} ({sisteAvlesningsDato})
                                </p>
                                <p className="marginTopMinus10">{this.props.avlesningstype}</p>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={10} sm={5} md={2}>
                            <FormGroup>
                                <ControlLabel>Forrige forbruk</ControlLabel>
                                <p>{this.props.sisteForbruk}</p>
                            </FormGroup>
                        </Col>
                    </Row>

                    <ButtonToolbar>
                        <Validation.components.Button className="btn btn-default hoeyde48">
                            OK
                        </Validation.components.Button>
                    </ButtonToolbar>
                </Validation.components.Form>
                {this.state.visInfoOmStand && (
                    <InfoOmStandModal
                        isOpen={this.state.visInfoOmStand}
                        onClose={this._closeInfoOmStandModal}
                        standErOk={this._standErOkFraDialog}
                        stand={this.state.stand}
                        forrigeStand={this.props.sisteStand}
                    />
                )}
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/gammelmaaler.jsx